import * as React from 'react'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'

export const CustomersInfoCard = () => {
  return (
    <div className="customer">
      <div className="">
        <iframe
          className="responsive-iframe"
          src="https://www.youtube.com/embed/81s3-QRaEvU?rel=0&controls=0"
          controls="0"
          frameborder="0"
          rel="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          style={{ width: 580, height: 327, borderRadius: 10 }}
        ></iframe>
      </div>
      <div className="customer-info">
        <p>
          With numerous vendors, recurring road expenses, workshop, fuel
          station, multiple branches, heavy governmental regulations & thousands
          of trips per month, J.K. Horgle Transport & Co. Ltd. transform its
          operation with Webbermill Transport Suite, the most complete & all
          integrated transport suite for bulk oil and gas transporters by road.
        </p>
        <div className="location">
          <StaticImage
            src="https://res.cloudinary.com/webbermill/image/upload/v1679606036/webbermill-website-assets/static/clients/jhk_izekuo.webp"
            alt="Banner"
            placeholder="blurred"
            layout="fixed"
            width={40}
            // height={400}
          />
          <div>
            <p>
              J.K. Horgle Transport and Co. Ltd <br />{' '}
              <small>Kpone, Tema.</small>
            </p>
          </div>
        </div>
        <div className="more-link">
          <Link to="">Learn More</Link>
          {/* <StaticImage
            src="../images/arrow-right.png"
            alt="Banner"
            placeholder="blurred"
            layout="fixed"
            width={20}
            // height={400}
          /> */}
        </div>
      </div>
    </div>
  )
}

export const FeaturesCard = ({ feature, src, name, description }) => {
  // console.log(imagePath);
  return (
    <>
      <div className={`product-card ${name}`}>
        <div className="content">
          <div className="image-box">
            <img src={src} alt="product" width={40} height={40} />
          </div>
          <h5>{feature}</h5>
          <p>{description}</p>
        </div>
      </div>
    </>
  )
}

export const BlogCard = ({ tag, excerpt, link, img, topic }) => {
  return (
    <>
      <div className="card-wrapper">
        <div className="img-container">
          <img src={img} alt="blog" />
        </div>
        <div className="card-text">
          <span>{tag}</span>
          <h5>{topic}</h5>
          <p>{excerpt}</p>
          <div className="read-btn d-flex justify-content-end">
            {/* <CustomLinkBtn text="Read more" url={link} target="_blank"/>  */}
            <Link to={link} target="_blank">
              Read More
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
